import React from 'react'

export const GarantyIcon = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M22.6666 30.0781C22.6666 30.3611 22.3808 30.5527 22.1181 30.4476L16.1485 28.0597C16.0532 28.0216 15.9468 28.0216 15.8514 28.0597L9.88185 30.4476C9.6191 30.5527 9.33329 30.3611 9.33329 30.0781C9.33329 28.6864 9.33329 25.1265 9.33329 22.667C11.3349 24.2507 13.6444 25.0877 16 25.083C18.3554 25.0878 20.6648 24.2515 22.6666 22.6687C22.6666 25.1268 22.6666 28.6864 22.6666 30.0781Z"
			fill="#4A4A4A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 25.3335C19.1826 25.3335 22.2348 24.0692 24.4853 21.8188C26.7357 19.5683 28 16.5161 28 13.3335C28 10.1509 26.7357 7.09865 24.4853 4.84821C22.2348 2.59778 19.1826 1.3335 16 1.3335C12.8174 1.3335 9.76516 2.59778 7.51472 4.84821C5.26428 7.09865 4 10.1509 4 13.3335C4 16.5161 5.26428 19.5683 7.51472 21.8188C9.76516 24.0692 12.8174 25.3335 16 25.3335Z"
			fill="#545563"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 25.3335C19.1826 25.3335 22.2348 24.0692 24.4853 21.8188C26.7357 19.5683 28 16.5161 28 13.3335C28 10.1509 26.7357 7.09865 24.4853 4.84821C22.2348 2.59778 19.1826 1.3335 16 1.3335C12.8174 1.3335 9.76516 2.59778 7.51472 4.84821C5.26428 7.09865 4 10.1509 4 13.3335C4 16.5161 5.26428 19.5683 7.51472 21.8188C9.76516 24.0692 12.8174 25.3335 16 25.3335Z"
			fill="url(#paint0_linear_28846_34241)"
		/>
		<path
			d="M12 13.6295L14.4615 15.9998L20 10.6665"
			stroke="white"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_28846_34241"
				x1="16"
				y1="1.3335"
				x2="16"
				y2="32.0835"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#568DFE" />
				<stop offset="0.846074" stopColor="#F4F8FC" />
			</linearGradient>
		</defs>
	</svg>
)
